// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__u5gg+","footer-nav":"Footer_footer-nav__XvRDp","footer-img":"Footer_footer-img__lfezr","footer-nav-container":"Footer_footer-nav-container__0f-2v"};